export default __webpack_public_path__ + "static/media/advance.716f8435.svg";